import React from 'react';
import { useSelector } from 'react-redux';

const PlayingBanner = () => {
    const { playing } = useSelector(state => state.playMovie);

    if (!playing) return null;

    const movieTitle = playing.movie?.title || 'Content';

    return (
        <div className="d-flex align-items-center gap-2 text-warning small">
            <span className="fas fa-play-circle" />
            <span>Now playing: {movieTitle}</span>
        </div>
    );
};

export default PlayingBanner;
